import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logoImg from "./../../assets/images/logo.png";
import Footer from './../../layout/main/Footer';
import { FrontendUrl } from "../../config";

class Guide extends Component<any, any> {
  render() {
    return (
      <>
        <section className='banner-area'>
          <Container>
            <Row className=' align-items-center'>
              <Col lg={12} className="mb-3 text-center">
                <img src={logoImg} />
              </Col>
              <Col lg={12} className="text-center">
              <video
                                id=""
                                width="100%"

                                controlsList="nodownload"
                                controls
                                autoPlay={true}
                                playsInline
                                src={`${FrontendUrl}uploads/Login-Guide-Video.mp4`}
                              />


              </Col>
            </Row>
          </Container>
        </section>
        <Footer    {...this.props} />
      </>
    );
  }
}

export default Guide;
